import { Injectable } from '@angular/core';
import { DataService } from '../data/data.service';
import { IMessage } from './messages.interface';
import { ERROR_MESSAGE_FOR_SELECTED_PRODUCT } from '../../utils/constants';

@Injectable({
  providedIn: 'root'
})
export class MessagesService {

  constructor(private data: DataService) { }

  addMessages(message: IMessage): void {
    this.data.messagesToDisplay$.next([message]);
  }

  clearMessages(): void {
    this.data.messagesToDisplay$.next([]);
  }

   showErrorMessage(err: { messages: string; }) {
        if (err) {
          const errorMessage: IMessage = {
            severity: 'error',
            text: err?.messages ? err?.messages : ERROR_MESSAGE_FOR_SELECTED_PRODUCT,
            icon: 'pi pi-ban'
          };
          this.data.messagesToDisplay$.next([errorMessage])
        }
      }

}
